import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = window.location.origin;

export const ForgotPassword = ({ onBackToLogin }) => {
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      const data = await response.json();

      if (response.ok) {
        setSent(true);
        toast.success('✅ Email envoyé !');
      } else {
        toast.error('❌ Erreur lors de l\'envoi');
        setLoading(false);
      }
    } catch (err) {
      console.error('Erreur:', err);
      toast.error('❌ Erreur de connexion au serveur');
      setLoading(false);
    }
  };

  if (sent) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center p-4">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center space-y-4">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-10 h-10 text-green-600" />
            </div>
            <CardTitle className="text-2xl">Email envoyé !</CardTitle>
            <CardDescription className="text-base">
              Un email de réinitialisation a été envoyé à<br />
              <strong className="text-blue-600">kophonelab@gmail.com</strong>
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded mb-6">
              <p className="text-sm text-gray-700">
                📧 Vérifiez votre boîte de réception et cliquez sur le lien pour réinitialiser votre mot de passe.
              </p>
              <p className="text-xs text-gray-600 mt-2">
                ⏰ Le lien expire dans 1 heure.
              </p>
            </div>
            <Button
              onClick={onBackToLogin}
              variant="outline"
              className="w-full flex items-center justify-center space-x-2"
            >
              <ArrowLeft size={18} />
              <span>Retour à la connexion</span>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-purple-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center space-y-2">
          <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
            <Mail className="w-8 h-8 text-blue-600" />
          </div>
          <CardTitle className="text-2xl">Mot de passe oublié ?</CardTitle>
          <CardDescription className="text-base">
            Un email de réinitialisation sera envoyé à<br />
            <strong className="text-blue-600">kophonelab@gmail.com</strong>
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 rounded">
              <p className="text-sm text-gray-700">
                💡 Un lien de réinitialisation sera envoyé à l'adresse email de l'administrateur.
              </p>
            </div>

            <Button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-2 border-white border-t-transparent mr-2"></div>
                  Envoi en cours...
                </>
              ) : (
                <>
                  <Mail size={18} className="mr-2" />
                  Envoyer le lien de réinitialisation
                </>
              )}
            </Button>

            <Button
              type="button"
              onClick={onBackToLogin}
              variant="ghost"
              className="w-full flex items-center justify-center space-x-2"
            >
              <ArrowLeft size={18} />
              <span>Retour à la connexion</span>
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
